import {Component, inject, signal} from '@angular/core'
import {form, FormField, required} from '@angular/forms/signals'
import {MatButton} from '@angular/material/button'
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog'
import {MatIcon} from '@angular/material/icon'
import {MatFormField, MatInput, MatLabel} from '@angular/material/input'
import {MatOption, MatSelect} from '@angular/material/select'
import {Router} from '@angular/router'
import {SIGN_PATH} from '../../general/shared'
import {IConsent} from '../../general/types'

export interface INewProject {
  projectName: string
  consentId: string
}

@Component({
  selector: 'smt-new-project-dialog',
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    MatOption,
    MatButton,
    MatIcon,
    MatDialogActions,
    MatDialogClose,
    FormField
  ],
  templateUrl: './new-project-dialog.component.html',
  styleUrl: './new-project-dialog.component.scss',
})
export class NewProjectDialog {

  public model = signal<INewProject>({
    projectName: '',
    consentId: ''
  })

  public form = form(this.model, p => {
    required(p.projectName)
    required(p.consentId)
  })

  public consents = signal<IConsent[]>([
    {
      id: '1',
      name: 'Generelt samtycke'
    },
    {
      id: '2',
      name: 'Modellsamtycke'
    }
  ])

  private readonly dialogRef = inject(MatDialogRef)
  private readonly router = inject(Router)

  public saveProject() {
    // Save project to BE and get a project id back
    this.dialogRef.close()
    this.router.navigate(['/', SIGN_PATH, '1']).then()
  }
}
